import React from "react";
import { UserIcon } from "lucide-react";
import S from "./styles.module.scss";

interface AvatarProps {
  src?: string;
  alt?: string;
  size?: number;
}

const Avatar = ({ src, alt = "Avatar", size = 32 }: AvatarProps) => (
  <span className={S.avatar} style={{ width: size, height: size }}>
    {src ? (
      <img src={src} alt={alt} />
    ) : (
      <UserIcon size={Math.round(size * 0.5)} />
    )}
  </span>
);

export default Avatar;
